import "./style.css";
import * as preline from "preline";

import { router } from "./router";
import { Crisp } from "crisp-sdk-web";
import { VerifyOverlay } from "./components/common/VerifyOverlay";
import * as Sentry from "@sentry/browser";
import Clarity from '@microsoft/clarity';
import posthog from 'posthog-js';
import {isPosthogTrackEnabled} from "./utils/util.ts";

export const mainComps = {
  verifyOverlay: VerifyOverlay()
};

function initializeApp() {
  router.resolve();
  preline.HSStaticMethods.autoInit();
  Crisp.configure(import.meta.env.VITE_CRISP_WEBSITE_ID);

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [],
    tracesSampleRate: 1.0,
    debug: true,
  });

  Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);

  if(isPosthogTrackEnabled()) {
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY,
        {
          api_host: 'https://us.i.posthog.com',
          person_profiles: 'always'
        }
    );
  }

  const gtmId = import.meta.env.VITE_GTM_ID;
  if (gtmId) {
    // Inject GTM <script>
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize dataLayer
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: 'gtm.js',
      'gtm.start': new Date().getTime()
    });

    // Inject <noscript> fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);
  }
}

if (document.readyState === "loading") {
  // if DOM is still loading, add initializeApp to the DOMContentLoaded event
  document.addEventListener("DOMContentLoaded", initializeApp);
} else {
  // DOM already loaded, run initializeApp immediately
  initializeApp();
}
